// Tryb — account and payout. The onboarding answers, editable after the fact.

import { ONBOARDING } from "@shared/fields.js";
import { countReq } from "@shared/validation.js";
import { Card, SectionTitle } from "../../components/Card.jsx";
import { FieldCell } from "../../components/TrybField.jsx";
import { useStudio } from "../../lib/studioContext.js";
import { useFieldViews } from "../../lib/useFieldViews.js";

export default function Account() {
  const { vals } = useStudio();
  const { fieldViews } = useFieldViews();

  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
      {ONBOARDING.filter((s) => !s.kyc).map((s) => {
        const c = countReq(s.ids, vals);
        return (
          <Card key={s.id} padding={28}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
              <SectionTitle>{s.title}</SectionTitle>
              <span style={{ fontFamily: "var(--font-mono)", fontSize: 11, color: "var(--text-muted)" }}>
                {c.done}/{c.total}
              </span>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
              {fieldViews(s.ids, true).map((f) => (
                <FieldCell key={f.id} f={f} />
              ))}
            </div>
          </Card>
        );
      })}
    </div>
  );
}
